import React, { useEffect, useRef } from 'react';

interface ResponsiveChartProps {
  children: React.ReactNode;
  ariaLabel?: string;
}

// Wrap charts to ensure they resize and update on container changes
const ResponsiveChart: React.FC<ResponsiveChartProps> = ({ children, ariaLabel }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const el = containerRef.current;
    const observer = new ResizeObserver(() => {
      // Trigger a resize event so Chart.js can recalc layout
      window.dispatchEvent(new Event('resize'));
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} aria-label={ariaLabel} role={ariaLabel ? 'img' : undefined} style={{ width: '100%', height: '100%' }}>
      {children}
    </div>
  );
};

export default ResponsiveChart;


